import { PopoverOrigin } from '../../BasePopoverContent';
import { PopoverContentPosition } from './types';

interface OriginValuesType {
  anchorOrigin: PopoverOrigin;
  spacing: string;
  transformOrigin: PopoverOrigin;
}

export const getOriginValues = (position?: PopoverContentPosition): OriginValuesType => {
  switch (position) {
    case 'bottom-start':
      return {
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        spacing: 'mt-8',
        transformOrigin: { horizontal: 'left', vertical: 'top' },
      };
    case 'bottom':
      return {
        anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
        spacing: 'mt-8',
        transformOrigin: { horizontal: 'center', vertical: 'top' },
      };
    case 'top-start':
      return {
        anchorOrigin: { horizontal: 'left', vertical: 'top' },
        spacing: '-mt-8',
        transformOrigin: { horizontal: 'left', vertical: 'bottom' },
      };
    case 'top':
      return {
        anchorOrigin: { horizontal: 'center', vertical: 'top' },
        spacing: '-mt-8',
        transformOrigin: { horizontal: 'center', vertical: 'bottom' },
      };
    case 'top-end':
      return {
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        spacing: '-mt-8',
        transformOrigin: { horizontal: 'right', vertical: 'bottom' },
      };
    case 'left-start': {
      return {
        anchorOrigin: { horizontal: 'left', vertical: 'top' },
        spacing: '-ms-8',
        transformOrigin: { horizontal: 'right', vertical: 'top' },
      };
    }
    case 'right-start': {
      return {
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        spacing: 'ms-8',
        transformOrigin: { horizontal: 'left', vertical: 'top' },
      };
    }
    case 'right': {
      return {
        anchorOrigin: { horizontal: 'right', vertical: 'center' },
        spacing: 'ms-8',
        transformOrigin: { horizontal: 'left', vertical: 'center' },
      };
    }
    case 'bottom-end':
    default:
      return {
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        spacing: 'mt-8',
        transformOrigin: { horizontal: 'right', vertical: 'top' },
      };
  }
};
